// Thanks to: https://github.com/airyland/vux/blob/v2/src/directives/transfer-dom/index.js
// Thanks to: https://github.com/calebroseland/vue-dom-portal

import isPlainObject from "lodash/isPlainObject"
import Vue from "vue"
import { getTarget } from "../utils/helper"

const POSITION_ABSOLUTE = "v-portal-absolute"
const POSITION_FIXED = "v-portal-fixed"

if (!Vue.prototype.$isServer) {
  const sheet = (() => {
    const style = document.createElement("style")
    style.appendChild(document.createTextNode(""))
    document.head.appendChild(style)
    return style.sheet
  })()

  sheet.insertRule(`[${POSITION_ABSOLUTE}] { position: absolute !important; }`, 0)
  sheet.insertRule(`[${POSITION_FIXED}] { position: fixed !important; }`, 0)
}

const setPortalPosition = (el, target) => {
  if (target === document.body) {
    el.setAttribute(POSITION_FIXED, "")
  } else {
    el.setAttribute(POSITION_ABSOLUTE, "")
  }
}
const removePortalPosition = el => {
  el.removeAttribute(POSITION_FIXED)
  el.removeAttribute(POSITION_ABSOLUTE)
}

const DEFAULT_OPTIONS = {
  target: true,
  disabled: false,
}

const parseOptions = ({ value }) => {
  let result = {}
  if (isPlainObject(value)) {
    result = value
  } else {
    result = {
      target: getTarget(value),
    }
  }
  return {
    ...DEFAULT_OPTIONS,
    ...result,
  }
}

export default {
  inserted(el, binding) {
    const { target, disabled } = parseOptions(binding)

    el.setAttribute("v-portal", "")

    let parentNode = el.parentNode

    const home = document.createComment("portal")
    let hasMovedOut = false

    if (!disabled) {
      if (target !== false) {
        if (parentNode) {
          parentNode.replaceChild(home, el) // moving out, el is no longer in the document
        } else {
          el.setAttribute("v-portal-independent", "")
        }
        target.appendChild(el) // moving into new place
        hasMovedOut = true
        setPortalPosition(el, target)
      }
    }

    if (!el.__transferDomData) {
      el.__transferDomData = {
        parentNode: parentNode,
        home: home,
        target: target,
        hasMovedOut: hasMovedOut,
      }
    }
  },
  componentUpdated(el, binding) {
    const { target, disabled } = parseOptions(binding)
    if (disabled) {
      return
    }

    const ref$1 = el.__transferDomData
    const { parentNode, home, hasMovedOut, target: lastTarget } = ref$1

    if (!hasMovedOut && target) {
      if (parentNode) {
        // remove from document and leave placeholder
        parentNode.replaceChild(home, el)
      } else {
        el.setAttribute("v-portal-independent", "")
      }

      setPortalPosition(el, target)

      // append to target
      target.appendChild(el)
      el.__transferDomData = {
        ...el.__transferDomData,
        hasMovedOut: true,
        target: target,
      }
    } else if (hasMovedOut && target === false) {
      if (parentNode) {
        // previously moved, coming back home
        parentNode.replaceChild(el, home)
      } else {
        el.removeAttribute("v-portal-independent")
        if (el.parentNode) {
          el.parentNode.removeChild(el)
        }
      }

      removePortalPosition(el)

      el.__transferDomData = {
        ...el.__transferDomData,
        hasMovedOut: false,
        target: target,
      }
    } else if (target !== lastTarget) {
      removePortalPosition(el)

      // already moved, going somewhere else
      target.appendChild(el)
      setPortalPosition(el, target)

      el.__transferDomData.target = target
    }
  },
  unbind(el) {
    el.removeAttribute("v-portal")

    const ref$1 = el.__transferDomData
    if (!ref$1) {
      return
    }

    const { parentNode, home, hasMovedOut } = ref$1

    if (hasMovedOut === true) {
      removePortalPosition(el)
      if (el.parentNode) {
        el.parentNode.removeChild(el)
      }

      if (parentNode) {
        parentNode.removeChild(home)
      } else {
        el.removeAttribute("v-portal-independent")
      }
    }

    el.__transferDomData = null
  },
}
